module.exports = __webpack_public_path__ + "static/copper_crm-3d8e9ab485d359f45b2f51a7486a671b.png";